import { CartLinesUpdateEvent } from '@shopify/events';

const updateCardPrice = (card) => {
  const option = card.querySelector('select[data-sling-variant]')?.selectedOptions[0];
  if (!option) return;
  card.querySelector('[data-sling-original]').textContent = option.dataset.original;
  card.querySelector('[data-sling-payable]').textContent = option.dataset.payable;
};

document.addEventListener('change', (event) => {
  if (!event.target.matches('select[data-sling-variant]')) return;
  updateCardPrice(event.target.closest('[data-sling-card]'));
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-sling-add]');
  if (!button || button.disabled) return;

  event.preventDefault();

  const card = button.closest('[data-sling-card]');
  const variantId = Number(card.querySelector('[data-sling-variant]').value);
  const deferred = CartLinesUpdateEvent.createPromise();

  button.disabled = true;
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });

    if (!addResponse.ok) {
      const error = await addResponse.json().catch(() => ({}));
      throw new Error(error.description || 'Could not add this sling to your cart.');
    }

    const cart = await (
      await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } })
    ).json();

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'cart-drawer-slings',
        sourceId: 'cart-drawer-recommendations',
        itemCount: 1,
        productId: card.dataset.productId,
      },
    });

    document.querySelectorAll('[data-sling-add]').forEach((item) => {
      item.disabled = true;
    });
  } catch (error) {
    deferred.reject(error);
    button.disabled = false;
    alert(error.message);
  }
});
